import { z } from 'zod';

/**
 * Причина, по которой SourceMessage в статусе EXTRACTED не был
 * авто-опубликован. Источник правды — `deriveAutoPublishSkipReason`
 * в `@upme/domain`.
 *
 * Для сообщений вне EXTRACTED — null.
 */
export const AutoPublishSkipReasonSchema = z.discriminatedUnion('code', [
  z.object({ code: z.literal('AUTOPUBLISH_DISABLED') }),
  z.object({ code: z.literal('NOT_AN_EVENT'), llmReason: z.string().nullable() }),
  z.object({
    code: z.literal('LOW_CONFIDENCE'),
    confidence: z.number().min(0).max(1),
    threshold: z.number().min(0).max(1),
  }),
  z.object({ code: z.literal('MULTI_DATE'), dates: z.number().int().nonnegative() }),
  z.object({ code: z.literal('NO_DATE') }),
  z.object({ code: z.literal('MISSING_TITLE') }),
]);

export type AutoPublishSkipReason = z.infer<typeof AutoPublishSkipReasonSchema>;
export type AutoPublishSkipReasonCode = AutoPublishSkipReason['code'];
